<template>
  <div class="user-info">
    <div class="items">
      <p>{{ $toLocal(data.tradesAmount,$decimal['TOMAN']) }}</p>
      <a>
        <img src="../../assets/Home/check.png" alt="">
        معامله انجام شده
      </a>
    </div>

    <div class="items">
      <p>{{ $toLocal(data.tradesValue,$decimal['TOMAN']) }}</p>
      <a>
        <img src="../../assets/Home/restore.png" alt="">
        حجم معاملات (تومان)
      </a>
    </div>

    <div class="items">
      <p>        {{ $toLocal(data.userCount,$decimal['TOMAN']) }}</p>
      <a>
        <img src="../../assets/Home/users.png" alt="">

      </a>
    </div>

  </div>
</template>

<script>
export default {
  name: "the-user-info",
  data() {
    return {

      //amounts of trades
      data: {}
    }
  },
  methods:{
    async getStats(){
      let response = await this.$axios.get('trades/market-info-home');
      // let content = response.baseDTO
 this.data=response.baseDTO
    }
  },
  mounted(){
    this.getStats();
  }
}
</script>

<style lang="scss" scoped>
.user-info {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items:baseline;
  direction: rtl;
  //height: 300px;
  gap: 20px;

  .items {
    display: flex;
    flex-direction: column;
    gap: 10px;
    font-size: clamp(14px , 2vw , 16px);

    p{
      color: #FBFBFD;
    }

    a {
      display: flex;
      flex-direction: row;
      gap: 10px;
      color: #FBFBFD;
      align-items: center;
    }
  }

}
@media(max-width: 400px){
  .user-info{
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
  }
}
</style>